import React, {Component} from "react";
import EditInstrumentView from "./EditInstrumentView";
import {Growl} from "primereact/growl";
import {InstrumentService} from "../../../../service/maintenance/instrument/InstrumentService";
import {isValidData} from "../../../../utils/validator/Fields";
import {HIGH_AVAILABILITY, LOW_AVAILABILITY, MEDIUM_AVAILABILITY} from "../../../../utils/constants/Constants";

export default class EditInsrumentContainer extends Component {
    constructor(props) {
        super(props);
        this.instrumentService = new InstrumentService();
        this.getClavesList = this.getClavesList.bind(this);

        this.state = {
            instrumentData: this.props.location.state.instrumentSelected,
            returnPath: this.props.location.state.returnPath,
            clavesList: this.getClavesList(),
            requiredFields: ['cupon', 'isin', 'idGSS', 'cveAforoObj'],
            availabilityList: [
                {id: HIGH_AVAILABILITY, availability: "Alta"},
                {id: MEDIUM_AVAILABILITY, availability: "Media"},
                {id: LOW_AVAILABILITY, availability: "Baja"}],
        };

        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.returnMaintenancePage = this.returnMaintenancePage.bind(this);
        this.updateInstrument = this.updateInstrument.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    getClavesList() {
        this.loading(true);
        this.instrumentService.getDataAforos()
            .then(resp => {
                let instrumentDataAux = this.state.instrumentData;
                instrumentDataAux['cveAforoObj'] =
                    resp.payload.find(item => item['aforoStr'] ===
                        this.props.location.state.instrumentSelected.cveAforo);
                instrumentDataAux['availabilityObj'] = {
                    id: this.props.location.state.instrumentSelected['idDemanda'],
                    availability: this.props.location.state.instrumentSelected['descDemanda'],
                }
                this.setState({
                    clavesList: resp.payload,
                    instrumentData: instrumentDataAux,
                });
                this.loading(false);
            })
    }


    onChangeInputText(event) {
        const {name, value} = event.target;
        let instrumentDataAux = this.state.instrumentData;
        instrumentDataAux[name] = value;
        this.setState({instrumentData: instrumentDataAux,})
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    returnMaintenancePage(message) {
        this.loading(false);
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    updateInstrument() {
        this.loading(true);
        if (!isValidData(this.state.requiredFields, this.state.instrumentData)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Por favor llene todos los campos requeridos correctamente'
            });
        } else {
            let messageObj = {};
            this.loading(true);
            this.instrumentService.modifyInstrument(this.state.instrumentData)
                .then(resp => {
                    if (resp.message === 'Success') {
                        let availability = [{
                            idEmisora: this.state.instrumentData.idEmisora,
                            idDemanda: this.state.instrumentData.availabilityObj.id,
                        }];
                        this.instrumentService.updateAvailability(availability).then(respAva => {
                            if (respAva.message === "Success") {
                                messageObj['severity'] = 'success';
                                messageObj['sumary'] = 'Éxito';
                                messageObj['detail'] = 'La emisora se modificó correctamente'
                            } else if (respAva.error !== "") {
                                messageObj['severity'] = 'error';
                                messageObj['sumary'] = 'Error';
                                messageObj['detail'] = respAva.error;
                            }
                            this.returnMaintenancePage(messageObj)
                        });
                    } else if (resp.error !== "") {
                        messageObj['severity'] = 'error';
                        messageObj['sumary'] = 'Error';
                        messageObj['detail'] = resp.error;
                        this.returnMaintenancePage(messageObj)
                    }

                });
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {instrumentData, isLoading, clavesList, availabilityList} = this.state;

        return <EditInstrumentView instrumentData={instrumentData}
                                   messagesGrowl={messagesGrowl}
                                   clavesList={clavesList}
                                   isLoading={isLoading}
                                   availabilityList={availabilityList}
                                   onChangeInputText={this.onChangeInputText}
                                   updateInstrument={this.updateInstrument}
                                   returnMaintenancePage={this.returnMaintenancePage}

        />
    }
};